import { render } from "./GroupPolicy.vue?vue&type=template&id=3d69cd54&scoped=true"
const script = {}

import "./GroupPolicy.vue?vue&type=style&index=0&id=3d69cd54&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d69cd54"]])

export default __exports__